import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { error: Error | null }> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    // Keep console output for debugging in production
    console.error('App crashed:', error);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, fontFamily: 'Jost, system-ui, -apple-system, Segoe UI, Roboto, sans-serif' }}>
          <h1 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Devine stone</h1>
          <p style={{ marginBottom: 12 }}>The app failed to load.</p>
          <pre style={{ whiteSpace: 'pre-wrap', background: '#fff7ed', border: '1px solid #fed7aa', padding: 12, borderRadius: 12 }}>
            {String(this.state.error?.stack || this.state.error?.message)}
          </pre>
        </div>
      );
    }

    return this.props.children;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);